<template>
  <div>
    <!-- 核心表现概览 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center m-b-20">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">核心表现概览</span>
      </div>
      <!--普通员工-->
      <template v-if="roleType != 13">
        <div class="flex row-between col-center m-b-20">
          <!-- 出勤率 -->
          <div :style="getBackgroundStyle('attendanceUrl')" class="width-30 b-r-8 p-16 text-center">
            <div class="font-32 font-weight-600 m-b-8">{{ boardData.kqsj?.attendanceRate }}%</div>
            <div class="font-24 m-b-32">出勤率</div>
            <div class="flex-col flex-gap-4 font-24">
              <span class="b-r-45 bg-B1FFE7 p-t-8 p-b-8 p-l-16 p-r-16">团队第{{ boardData.kqsj?.attendanceSort }}名</span>
              <span :class="boardData.kqsj?.attendanceRate > boardData.kqsj?.averageRate ? 'cor-00B719' : 'cor-FE4C4E'">
              {{ boardData.kqsj?.attendanceRate > boardData.kqsj?.averageRate ? '高于' : '低于' }}均值
              <span v-if="boardData.kqsj">
                {{ Number(Math.abs(boardData.kqsj?.attendanceRate - boardData.kqsj?.averageRate).toFixed(0)) }}%
              </span>
              <span v-else>-%</span>
            </span>
            </div>
          </div>
          <!-- 平均绩效分 -->
          <div :style="getBackgroundStyle('performanceUrl')" class="width-30 b-r-8 p-16 text-center">
            <div class="font-32 font-weight-600 m-b-8">{{ boardData.performance.proportion ? boardData.performance.proportion : '-' }}</div>
            <div class="font-24 m-b-32">平均绩效分</div>
            <div class="flex-col flex-gap-4 font-24">
              <span class="b-r-45 bg-FFE8AF p-t-8 p-b-8 p-l-16 p-r-16">团队第{{ boardData.performance?.ranking == 0 ? '-' : boardData.performance?.ranking }}名</span>
              <span :class="boardData.performance?.proportion > boardData.performance?.mean ? 'cor-00B719' : 'cor-FE4C4E'">
              {{ boardData.performance?.proportion > boardData.performance?.mean ? '高于' : '低于' }}均值
              <span v-if="boardData.performance">
                {{ Number(Math.abs(boardData.performance?.proportion - boardData.performance?.mean).toFixed(0)) }}分
              </span>
              <span v-else>-分</span>
            </span>
            </div>
          </div>
          <!-- 及时反馈率 -->
          <div :style="getBackgroundStyle('feedbackUrl')" class="width-30 b-r-8 p-16 text-center">
            <div class="font-32 font-weight-600 m-b-8">{{ boardData.feedback?.proportion == 0 ? '-' : boardData.feedback?.proportion }}%</div>
            <div class="font-24 m-b-32">及时反馈率</div>
            <div class="flex-col flex-gap-4 font-24">
              <span class="b-r-45 bg-A4B7FF p-t-8 p-b-8 p-l-16 p-r-16">团队第{{ boardData.feedback?.ranking == 0 ? '-' : boardData.feedback?.ranking }}名</span>
              <span :class="boardData.feedback?.proportion > boardData.feedback?.mean ? 'cor-00B719' : 'cor-FE4C4E'">
              {{ boardData.feedback?.proportion > boardData.feedback?.mean ? '高于' : '低于' }}均值
              <span v-if="boardData.feedback">
                {{ Number(Math.abs(boardData.feedback?.proportion - boardData.feedback?.mean).toFixed(0)) }}%
              </span>
              <span v-else>-%</span>
            </span>
            </div>
          </div>
        </div>
        <!-- 合同签订 -->
        <div v-for="(item, index) in boardData.hthk" :key="index" class="flex col-center m-b-20 p-16 bg-F5F9FF b-r-8">
          <div class="w-72 h-72 m-r-16">
            <img v-if="item.type == 1" alt="合同" class="width-100 height-100" src="@/assets/icon/employeeKanban/contract.png">
            <img v-if="item.type == 2" alt="回款" class="width-100 height-100" src="@/assets/icon/employeeKanban/revenue.png">
          </div>
          <div class="width-90">
            <div class="font-28 m-b-8">
            <span class="font-28">{{ item.type == 1 ? '合同签订' : '回款金额' }}：
              <span class="font-40 font-weight-700">
                {{ item.amount == 0 ? '-' : Number(parseFloat(item.amount) / 10000).toFixed(2) }}
              </span>
              <span class="font-24">万元</span>
            </span>
            </div>
            <div class="text-right font-24">
              <span :style="{'border': `1px solid ${item.type == 1 ? '#f7b700' : '#36CE87'}`}" class="dis-in-b h-44 l-h-44 p-l-20 p-r-20 m-r-8 b-r-90">贡献率{{ item.rate == 0 ? '-' : item.rate }}%</span>
              <span :style="{'border': `1px solid ${item.type == 1 ? '#f7b700' : '#36CE87'}`}" class="dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r b-r-90">团队第{{ item.ranking == 0 ? '-' : item.ranking }}名</span>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="flex col-center m-b-20 p-16 bg-F5F9FF b-r-8">
          <div class="w-72 h-72 m-r-16">
            <img alt="出勤率" class="width-100 height-100" src="@/assets/icon/employeeKanban/caiwu/cql.png">
          </div>
          <div class="width-90">
            <div class="font-28 m-b-8">
            <span class="font-28">出勤率：
              <span class="font-40">
                <span class="font-weight-700">{{ boardData.kqsj?.attendanceRate }}</span>%
              </span>
            </span>
            </div>
            <div class="text-right font-24">
              <span class="dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r b-r-90 m-r-8" style="border: 1px solid #85F3D1;">团队第{{ boardData.kqsj?.attendanceSort }}名</span>
              <span :class="boardData.kqsj?.attendanceRate > boardData.kqsj?.averageRate ? 'cor-00B719' : 'cor-FE4C4E'" class="dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r-90" style="border: 1px solid #85F3D1;">
              {{ boardData.kqsj?.attendanceRate > boardData.kqsj?.averageRate ? '高于' : '低于' }}均值
              <span v-if="boardData.kqsj">
                {{ Number(Math.abs(boardData.kqsj?.attendanceRate - boardData.kqsj?.averageRate).toFixed(0)) }}%
              </span>
              <span v-else>-%</span>
            </span>
            </div>
          </div>
        </div>
        <div class="flex col-center m-b-20 p-16 bg-F5F9FF b-r-8">
          <div class="w-72 h-72 m-r-16">
            <img alt="平均绩效分" class="width-100 height-100" src="@/assets/icon/employeeKanban/caiwu/jxf.png">
          </div>
          <div class="width-90">
            <div class="font-28 m-b-8">
            <span class="font-28">平均绩效分：
              <span class="font-40">
                <span class="font-weight-700">{{ boardData.performance.proportion ? boardData.performance.proportion : '-' }}</span>%
              </span>
            </span>
            </div>
            <div class="text-right font-24">
              <span class="dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r b-r-90 m-r-8" style="border: 1px solid #F7B700;">团队第{{ boardData.performance?.ranking == 0 ? '-' : boardData.performance?.ranking }}名</span>
              <span :class="boardData.performance?.proportion > boardData.performance?.mean ? 'cor-00B719' : 'cor-FE4C4E'" class="dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r-90" style="border: 1px solid #F7B700;">
              {{ boardData.performance?.proportion > boardData.performance?.mean ? '高于' : '低于' }}均值
              <span v-if="boardData.performance">
                {{ Number(Math.abs(boardData.performance?.proportion - boardData.performance?.mean).toFixed(0)) }}分
              </span>
              <span v-else>-分</span>
            </span>
            </div>
          </div>
        </div>
        <div class="flex col-center m-b-20 p-16 bg-F5F9FF b-r-8">
          <div class="w-72 h-72 m-r-16">
            <img alt="及时反馈率" class="width-100 height-100" src="@/assets/icon/employeeKanban/caiwu/fkl.png">
          </div>
          <div class="width-90">
            <div class="font-28 m-b-8">
            <span class="font-28">及时反馈率：
              <span class="font-40">
                <span class="font-weight-700">{{ boardData.feedback?.proportion == 0 ? '-' : boardData.feedback?.proportion }}</span>%
              </span>
            </span>
            </div>
            <div class="text-right font-24">
              <span class="dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r b-r-90 m-r-8" style="border: 1px solid #A4B7FF;">团队第{{ boardData.feedback?.ranking == 0 ? '-' : boardData.feedback?.ranking }}名</span>
              <span :class="boardData.feedback?.proportion > boardData.feedback?.mean ? 'cor-00B719' : 'cor-FE4C4E'" class="dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r-90" style="border: 1px solid #A4B7FF;">
              {{ boardData.feedback?.proportion > boardData.feedback?.mean ? '高于' : '低于' }}均值
              <span v-if="boardData.feedback">
                {{ Number(Math.abs(boardData.feedback?.proportion - boardData.feedback?.mean).toFixed(0)) }}%
              </span>
              <span v-else>-%</span>
            </span>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- 考勤统计 -->
    <div class="bg-FF b-r-8">
      <div class="flex space-between col-center p-t-16 p-l-16 p-r-16">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">考勤统计</span>
      </div>
      <div class="flex flex-wrap p-b-20">
        <div class="m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24" style="width: 45.4%">
          <div class="w-72 h-72 m-r-16">
            <img alt="迟到" class="width-100 height-100" src="@/assets/icon/employeeKanban/late.png">
          </div>
          <div>
            <div class="font-40 font-weight-700">{{ boardData.kqsj?.cdcs }}</div>
            <div class="font-24">迟到次数</div>
          </div>
        </div>

        <div class="m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24" style="width: 45.4%">
          <div class="w-72 h-72 m-r-16">
            <img alt="早退" class="width-100 height-100" src="@/assets/icon/employeeKanban/early.png">
          </div>
          <div>
            <div class="font-40 font-weight-700">{{ boardData.kqsj?.ztcs }}</div>
            <div class="font-24">早退次数</div>
          </div>
        </div>

        <div class="m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24" style="width: 45.4%">
          <div class="w-72 h-72 m-r-16">
            <img alt="请假" class="width-100 height-100" src="@/assets/icon/employeeKanban/leave.png">
          </div>
          <div>
            <div class="font-40 font-weight-700">{{ boardData.kqsj?.leaveDays }}</div>
            <div class="font-24">请假次数</div>
          </div>
        </div>

        <div class="m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24" style="width: 45.4%">
          <div class="w-72 h-72 m-r-16">
            <img alt="旷工" class="width-100 height-100" src="@/assets/icon/employeeKanban/absent.png">
          </div>
          <div>
            <div class="font-40 font-weight-700">{{ boardData.kqsj?.kgcs }}</div>
            <div class="font-24">旷工次数</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import TitleLogo from "@/components/TitleLogo.vue";

export default {
  components: {TitleLogo},
  props: {
    boardData: {
      type: Object,
      default: () => ({})
    },
    roleType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      performanceList: [],
      attendanceUrl: require('@/assets/icon/employeeKanban/attendance.png'),
      performanceUrl: require('@/assets/icon/employeeKanban/performance.png'),
      feedbackUrl: require('@/assets/icon/employeeKanban/feedback.png'),
      attendanceItems: [
        {
          icon: require('@/assets/icon/employeeKanban/late.png'),
          label: '迟到次数',
          count: this.boardData.kqsj?.cdcs,
        },
        {
          icon: require('@/assets/icon/employeeKanban/early.png'),
          label: '早退次数',
          count: this.boardData.kqsj?.ztcs,
        },
        {
          icon: require('@/assets/icon/employeeKanban/leave.png'),
          label: '请假次数',
          count: this.boardData.kqsj?.leaveDays,
        },
        {
          icon: require('@/assets/icon/employeeKanban/absent.png'),
          label: '旷工次数',
          count: this.boardData.kqsj?.kgcs,
        }
      ]
    }
  },
  mounted() {
  },
  created() {
  },
  methods: {
    getBackgroundStyle(imgSrc) {
      return {
        'background-image': `url(${this[imgSrc]})`,
        'background-size': 'cover',
        'background-repeat': 'no-repeat'
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>
